export const resizeFontSize = ({ container, text }) => {
    const ratioY = container.clientHeight / text.clientHeight;
    const ratioX = container.clientWidth / text.clientWidth;

    if (ratioY < 1 || ratioX < 1) {
        const textFontSize = parseInt(getComputedStyle(text).fontSize);

        text.style.fontSize = `${textFontSize - 1}px`;
        resizeFontSize({ container, text });
    }
};
